export function analyticsInitializer() {
  const src: string = (window as any).__env__.analyticsScript;
  const script: HTMLScriptElement = document.createElement('script');

  script.setAttribute('src', src);
  script.async = true;
  document.head.appendChild(script);
}
